import { Product } from '@italist/grpc-proto/entities/product_pb';

import { SelectorOption } from 'components/pages/ProductDetails/types/SelectorOption';
import { normalizeSizeSelectorOptionsOrder, normalizeSizeValueName } from 'helpers/sizeHelper';

export const getSelector = ({
  sizesList,
  sizeSystem,
}: {
  sizeSystem: string;
  sizesList: Product.Size.AsObject[];
}): {
  selectorOptions: SelectorOption[];
  selectorTitleText: string;
} => {
  const selectorTitleText = sizeSystem ? `Size: ${sizeSystem}` : 'Size';
  const selectorOptions = normalizeSizeSelectorOptionsOrder(
    sizesList.map(option => {
      const { numberAvailable, productVersionOptionId: value, size: rawSize } = option;
      const size = normalizeSizeValueName(rawSize);
      return {
        label: `${size}${sizeSystem && !size.includes(sizeSystem) ? ` (${sizeSystem})` : ''}`,
        numberAvailable,
        rawSize,
        size,
        value,
      };
    }),
    sizeSystem,
  );
  return { selectorOptions, selectorTitleText };
};
